import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import { rootSaga } from "./sagas";
import assetReducer from "./slices/assetSlice";
import authReducer from "./slices/authSlice";
import companiesReducer from "./slices/companiesSlice";
import deviceReducer from "./slices/deviceSlice";
import gatewayReducer from "./slices/gatewaySlice";
import incidentsReducer from "./slices/incidentsSlice";
import modalReducer from "./slices/modalSlice";
import navGuardReducer from "./slices/navGuardSlice";
import notificationSettingsReducer from "./slices/notificationSettingsSlice";
import portfolioReducer from "./slices/portfolioSlice";
import reportsReducer from "./slices/reportsSlice";
import toastReducer from "./slices/toastSlice";
import usersReducer from "./slices/usersSlice";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    modal: modalReducer,
    companies: companiesReducer,
    toast: toastReducer,
    portfolios: portfolioReducer,
    assets: assetReducer,
    users: usersReducer,
    gateways: gatewayReducer,
    devices: deviceReducer,
    incidents: incidentsReducer,
    reports: reportsReducer,
    navGuard: navGuardReducer,
    notificationSettings: notificationSettingsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootStore = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
